import { Component } from '@angular/core';
import { BroadcastService } from '../../service/broadcast.service';
import { BroadcastEventModel } from '../../model/broadcast-event.model';

export const CONTENT_LOADER_EVENT = 'contentLoaderEvent';

export const LOADER_SHOW = true;
export const LOADER_HIDE = false;

@Component({
	selector: 'cv-content-loader',
	templateUrl: './content-loader.component.html',
	styleUrls: ['./content-loader.component.scss']
})
export class ContentLoaderComponent {

	/**
	 * To control if the Loader is on or off
	 */
	public isLoader = false;
	/**
	 * If wants or not to show the spinner
	 */
	public isSpinnerOn = true;
	/**
	 * Message to show on the Loading Process
	 */
	public message = '';
	/**
	 * Determines if sub-message should be displayed or not.
	 */
	public hideSubMessage = false;

	constructor(private broadcastService: BroadcastService) {
		this.registerRouteEndListener();
	}

	/**
	 * Register Lister to Show/Hide the Loader
	 */
	private registerRouteEndListener(): void {
		this.broadcastService.on(CONTENT_LOADER_EVENT, (broadcast: BroadcastEventModel) => {
			this.isLoader = broadcast.event.isLoader;
			this.hideSubMessage = broadcast.event.hideSubMessage || false;
			this.isSpinnerOn = (broadcast.event.isSpinnerOn === undefined) ? true : broadcast.event.isSpinnerOn;
			this.message = broadcast.event.message;
		});
	}

}
